import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home',    to: '/'        },
  { label: 'Gallery', to: '/gallery' },
];
const INSTAGRAM_URL = 'https://www.instagram.com/framesbybhagya';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  useEffect(() => {
    setIsAdmin(!!localStorage.getItem('admin_token'));
  }, []);

  return (
    <nav style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, background: scrolled ? 'var(--color-bg)' : 'transparent', borderBottom: scrolled ? '1px solid var(--color-border)' : 'none', transition: 'background 0.3s ease' }}>

      <div style={{ maxWidth: 1280, margin: '0 auto', padding: '18px 32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

        <Link to="/" style={{ fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 400, letterSpacing: '0.05em', color: scrolled ? 'var(--color-text)' : '#fff', textDecoration: 'none' }}>
          @framesbybhagya
        </Link>

        {!isMobile && (
          <div style={{ display: 'flex', gap: 28, alignItems: 'center' }}>
            {NAV_LINKS.map(link => (
              <Link key={link.to} to={link.to} style={{ fontFamily: 'var(--font-body)', fontSize: 12, letterSpacing: '0.12em', textTransform: 'uppercase', textDecoration: 'none', color: location.pathname === link.to ? 'var(--color-accent)' : scrolled ? 'var(--color-muted)' : 'rgba(255,255,255,0.85)' }}>
                {link.label}
              </Link>
            ))}
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" style={{ fontFamily: 'var(--font-body)', fontSize: 12, letterSpacing: '0.12em', textTransform: 'uppercase', textDecoration: 'none', color: scrolled ? 'var(--color-accent)' : 'rgba(255,255,255,0.85)' }}>
              Instagram
            </a>
            <Link to="/contact" style={{ fontFamily: 'var(--font-body)', fontSize: 12, letterSpacing: '0.12em', textTransform: 'uppercase', textDecoration: 'none', color: location.pathname === '/contact' ? 'var(--color-accent)' : scrolled ? 'var(--color-muted)' : 'rgba(255,255,255,0.85)' }}>
              Contact
            </Link>
            <Link to="/about" style={{ fontFamily: 'var(--font-body)', fontSize: 12, letterSpacing: '0.12em', textTransform: 'uppercase', textDecoration: 'none', color: location.pathname === '/about' ? 'var(--color-accent)' : scrolled ? 'var(--color-muted)' : 'rgba(255,255,255,0.85)' }}>
              About
            </Link>
            {isAdmin && (
              <Link to="/admin/dashboard" target="_blank" rel="noopener noreferrer" style={{ fontFamily: 'var(--font-body)', fontSize: 12, letterSpacing: '0.12em', textTransform: 'uppercase', textDecoration: 'none', color: 'var(--color-accent)' }}>
                Dashboard
              </Link>
            )}
          </div>
        )}

        {isMobile && (
          <button onClick={() => setMenuOpen(v => !v)} aria-label="Menu" style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', flexDirection: 'column', gap: 5, padding: 4 }}>
            <span style={{ width: 24, height: 2, borderRadius: 1, display: 'block', background: scrolled ? 'var(--color-text)' : '#fff' }} />
            <span style={{ width: 24, height: 2, borderRadius: 1, display: 'block', background: scrolled ? 'var(--color-text)' : '#fff' }} />
            <span style={{ width: 24, height: 2, borderRadius: 1, display: 'block', background: scrolled ? 'var(--color-text)' : '#fff' }} />
          </button>
        )}

      </div>

      {isMobile && menuOpen && (
        <div style={{ background: 'var(--color-bg)', borderBottom: '1px solid var(--color-border)', padding: '16px 32px', display: 'flex', flexDirection: 'column', gap: 16 }}>
          {NAV_LINKS.map(link => (
            <Link key={link.to} to={link.to} onClick={() => setMenuOpen(false)} style={{ fontFamily: 'var(--font-body)', fontSize: 13, letterSpacing: '0.1em', textTransform: 'uppercase', textDecoration: 'none', color: location.pathname === link.to ? 'var(--color-accent)' : 'var(--color-muted)' }}>
              {link.label}
            </Link>
          ))}
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" style={{ fontFamily: 'var(--font-body)', fontSize: 13, letterSpacing: '0.1em', textTransform: 'uppercase', textDecoration: 'none', color: 'var(--color-accent)' }}>
            Instagram
          </a>
          <Link to="/contact" onClick={() => setMenuOpen(false)} style={{ fontFamily: 'var(--font-body)', fontSize: 13, letterSpacing: '0.1em', textTransform: 'uppercase', textDecoration: 'none', color: location.pathname === '/contact' ? 'var(--color-accent)' : 'var(--color-muted)' }}>
            Contact
          </Link>
          <Link to="/about" onClick={() => setMenuOpen(false)} style={{ fontFamily: 'var(--font-body)', fontSize: 13, letterSpacing: '0.1em', textTransform: 'uppercase', textDecoration: 'none', color: location.pathname === '/about' ? 'var(--color-accent)' : 'var(--color-muted)' }}>
            About
          </Link>
          {isAdmin && (
            <Link to="/admin/dashboard" target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpen(false)} style={{ fontFamily: 'var(--font-body)', fontSize: 13, letterSpacing: '0.1em', textTransform: 'uppercase', textDecoration: 'none', color: 'var(--color-accent)' }}>
              Dashboard
            </Link>
          )}
        </div>
      )}

    </nav>
  );
}